// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__Sc06E","tab":"Tabs_tab__qD5Lx","tabActive":"Tabs_tabActive__15HfZ"};